import React, { Component } from "react";
import MediaQuery from "react-responsive";
import moment from "moment-timezone";
import { css } from "glamor";

import EventScheduleCompressedTable from "./EventScheduleCompressedTable.js";
import EventScheduleFullSizeTable from "./EventScheduleFullSizeTable";
import ContentWrapper from "./ContentWrapper";
import DaySwitcher from "./DaySwitcher";

moment.tz.setDefault("America/Kingston");
const schedule = [
  {
    startDate: "2022-01-28T17:00:00",
    endDate: "2022-01-28T18:30:00",
    eventName: "Event Begins & Registration",
    subtitle: "Participants Log Onto Platforms",
    location: "Discord, Hopin and Devpost"
  },
  {
    startDate: "2022-01-28T18:30:00",
    endDate: "2022-01-28T19:00:00",
    eventName: "Opening Ceremony",
    subtitle: "Join us for the Opening Ceremony to start off the hackathon",
    location: "Hopin - Stage"
  },
  {
    startDate: "2022-01-28T19:00:00",
    endDate: "2022-01-28T20:00:00",
    eventName: "Fireside Chat (Entrepreneurship: A Winding Road to Success)",
    subtitle: "Take on new perspectives of the challenges and opportunities that start-up founders face!",
    location: "Hopin - Stage"
  },  
  {
    startDate: "2022-01-28T20:00:00",
    endDate: "2022-01-28T20:55:00",
    eventName: "Workshop: Hammer of the Gods",
    subtitle: "Introduction to Hammer of the Gods & Their API",
    location: "Hopin - Sessions"
  },
  {
    startDate: "2022-01-28T20:00:00",
    endDate: "2022-01-28T20:30:00",
    eventName: "Team formation",
    subtitle: "This will take place on Glimpse. Please visit #find-a-team on Discord for more information.",
    location: "Virtually"
  },
  {
    startDate: "2022-01-28T20:30:00",
    endDate: "",
    eventName: "Hacking Begins!",
    subtitle: "",
    location: "Discord - Announcements"
  },
  {
    startDate: "2022-01-28T21:00:00",
    endDate: "2022-01-28T21:00:00",
    eventName: "Event - National Geographic Stream",
    subtitle: "",
    location: "Hopin - Stage"
  },
  {
    startDate: "2022-01-29T10:00:00",
    endDate: "2022-01-29T10:40:00",
    eventName: "Resume Roast hosted by Slalom",
    subtitle: "Join Slalom's Tech Talent Acquisition team to show you what resumes will grab a company's attention!",
    // subtitle: "Have you ever wondered how to grab a company's attention when applying for a position? A member from Slalom's Tech Talent Acquisition will let you in on the do's and don'ts of creating resumes!",
    location: "Hopin - Sessions"
  },
  {
    startDate: "2022-01-29T11:00:00",
    endDate: "2022-01-29T11:55:00",
    eventName: "Workshop: Gameloft (The Makings of a Video Game)",
    subtitle: "Gameloft's Studio Manager and Technical Lead is here to let you in on how a video game is made!",
    // subtitle: "Gameloft's Studio Manager and Technical Lead is here to let you in on how a video game is made. Hear more about the process and tools behind producing a game from start to finish!",
    location: "Hopin - Sessions"
  },
  {
    startDate: "2022-01-29T12:00:00",
    endDate: "2022-01-29T12:55:00",
    eventName: "Lunch & Learn: Leading Learners (Networking 101)",
    subtitle: "Join this workshop hosted by the Founder of Leading Learners to improve your networking skills!",
    location: "Hopin - Sessions"
  },
  {
    startDate: "2022-01-29T13:00:00",
    endDate: "2022-01-29T13:55:00",
    eventName: "USSF Space Force CTF Challenge hosted by MLH",
    subtitle: "USSF Space Force CTF Challenge. This event will take place on Discord - #ussf-challenge-mlh .    ",
    location: "Discord - #ussf-challenge-mlh"
  },
  {
    startDate: "2022-01-29T14:00:00",
    endDate: "2022-01-29T15:30:00",
    eventName: "Career Fair & Open Networking",
    subtitle: "Meet firm reps from over 10 companies - you won't want to miss out on this!",
    location: "Hopin - Expo"
  },
  {
    startDate: "2022-01-29T15:30:00",
    endDate: "2022-01-29T16:00:00",
    eventName: "Break",
    subtitle: "",
    location: ""
  },
  {
    startDate: "2022-01-29T16:00:00",
    endDate: "2022-01-29T16:55:00",
    eventName: "Workshop: Scotiabank (How to Land Your Dream Internship)",
    subtitle: "Come learn tips and tricks on how to land your dream internship, hosted by Scotiabank!",
    location: "Hopin - Sessions"
  },
  {
    startDate: "2022-01-29T17:00:00",
    endDate: "2022-01-29T17:55:00",
    eventName: "Workshop: Smile CDR (Ask Me Anything)",
    subtitle: "10 Smile CDR representatives are ready to take on your questions about the company, industry, and anything else!",
    location: "Hopin - Sessions"
  },
  {
    startDate: "2022-01-29T18:00:00",
    endDate: "2022-01-29T18:55:00",
    eventName: "Mini Event: QHacks Kahoot",
    subtitle: "Come out and test your hackathon knowledge with us!",
    location: "Hopin - Stage"
  },
  {
    startDate: "2022-01-29T19:00:00",
    endDate: "2022-01-29T19:55:00",
    eventName: "Panel Talk: Recent Grads Unfiltered",
    subtitle: "Gain insight into the challenges and opportunities that new graduates may face when starting their careers!",
    location: "Hopin - Sessions"
  },
  {
    startDate: "2022-01-29T20:00:00",
    endDate: "2022-01-29T21:30:00",
    eventName: "Mini Event - Binarygames",
    subtitle: "Take a break and come join the QHacks team for some fun games on Discord!",
    location: "Discord"
  },
  {
    startDate: "2022-01-30T08:30:00",
    endDate: "",
    eventName: "Hacking Ends",
    subtitle: "",
    location: "Devpost"
  },
  {
    startDate: "2022-01-30T10:00:00",
    endDate: "2022-01-30T12:30:00",
    eventName: "Judging",
    subtitle: "*Judging will take place via Zoom. Check Discord for the presentation schedule and the Zoom links. Hackers will have 5 minutes to present and 5 minutes of Q&A.",
    location: "Zoom"
  },
  {
    startDate: "2022-01-30T10:00:00",
    endDate: "2022-01-30T12:30:00",
    eventName: "Game Roulette",
    subtitle: "Congratulate yourself on a job well down and join us for some games on Discord #game-roulette - there will be Codenames, Gartic Phone, and Skribbl!",
    location: "Zoom"
  },
  {
    startDate: "2022-01-30T12:30:00",
    endDate: "2022-01-30T13:30:00",
    eventName: "Final Judging Round - Top 5 Teams",
    subtitle: "*Judging will take place via Zoom. Check Discord for the presentation schedule and the Zoom links. The top 5 teams will be presenting again to a panel of judges.",
    location: "Zoom"
  },
  {
    startDate: "2022-01-30T13:30:00",
    endDate: "2022-01-30T14:00:00",
    eventName: "Break",
    subtitle: "",
    location: ""
  },
  {
    startDate: "2022-01-30T14:00:00",
    endDate: "2022-01-30T14:30:00",
    eventName: "Closing Ceremony",
    subtitle: "Join us for the Closing Ceremony to find out the winners of QHacks 2022!",
    location: "Hopin - Stage"
  },
  {
    startDate: "2022-01-30T15:00:00",
    endDate: "",
    eventName: "Event Ends",
    subtitle: "",
    location: ""
  },
];
// duration in minutes, startDate as ISO 8601
// const schedule = [
//   {
//     startDate: "2021-01-22T17:00:00",
//     endDate: "",
//     eventName: "Event Begins",
//     subtitle: "Participants Log Onto Platforms",
//     location: "Discord, Hopin and Devpost"
//   },
//   {
//     startDate: "2021-01-22T17:00:00",
//     endDate: "2021-01-22T18:30:00",
//     eventName: "Registration & Dinner",
//     subtitle: "",
//     location: "Hopin - Reception"
//   },
//   {
//     startDate: "2021-01-22T18:30:00",
//     endDate: "2021-01-22T20:00:00",
//     eventName: "Opening Ceremony & Fireside Chat",
//     subtitle: "",
//     location: "Hopin - Stage/Session"
//   },
//   {
//     startDate: "2021-01-22T20:00:00",
//     endDate: "2021-01-22T20:30:00",
//     eventName: "Team Formation & Finding Hackerspace",
//     subtitle: "",
//     location: "Discord & Glimpse"
//   },
//   {
//     startDate: "2021-01-22T20:30:00",
//     endDate: "",
//     eventName: "Hacking Begins!",
//     subtitle: "",
//     location: "Discord - Announcements"
//   },
//   {
//     startDate: "2021-01-22T21:00:00",
//     endDate: "2021-01-22T21:55:00",
//     eventName: "Workshop | DCL (Data Science)",
//     subtitle:"",
//     location: "Hopin - Sessions"
//   },
//   {
//     startDate: "2021-01-22T22:00:00",
//     endDate: "2021-01-22T23:00:00",
//     eventName: "(Almost) Midnight Snack",
//     subtitle: "Video Stream & Kahoot",
//     location: "Discord - Games"
//   },
//   {
//     startDate: "2021-01-23T08:00:00",
//     endDate: "2021-01-23T08:55:00",
//     eventName: "Breakfast & Learn",
//     subtitle: "Networking and Job Search",
//     location: "Hopin - Sessions"
//   },
//   {
//     startDate: "2021-01-23T09:00:00",
//     endDate: "2021-01-23T09:55:00",
//     eventName: "Workshop | Microsoft",
//     subtitle: "Machine Learning - Creating and Testing your own ML model using Azure",
//     location: "Hopin - Sessions"
//   },
//   {
//     startDate: "2021-01-23T10:00:00",
//     endDate: "2021-01-23T10:55:00",
//     eventName: "Workshop | FDM",
//     subtitle: "Java Multi-Threading",
//     location: "Hopin - Sessions"
//   },
//   {
//     startDate: "2021-01-23T11:00:00",
//     endDate: "2021-01-23T11:55:00",
//     eventName: "Panel Talk | Women in STEM",
//     subtitle: "",
//     location: "Hopin - Sessions"
//   },
//   {
//     startDate: "2021-01-23T12:00:00",
//     endDate: "2021-01-23T12:55:00",
//     eventName: "Lunch & Learn",
//     subtitle: "IBM - LinkedIn Workshop",
//     location: "Hopin - Sessions"
//   },
//   {
//     startDate: "2021-01-23T13:00:00",
//     endDate: "2021-01-23T13:55:00",
//     eventName: "Workshop | ROGERS",
//     subtitle: "How I landed a Job in a Pandemic and Tips for Hackathons",
//     location: "Hopin - Sessions"
//   },
//   {
//     startDate: "2021-01-23T14:00:00",
//     endDate: "2021-01-23T15:30:00",
//     eventName: "Career Fair",
//     subtitle: "+ Scattergories in Discord - Games ",
//     location: "Hopin - Expo"
//   },
//   {
//     startDate: "2021-01-23T16:00:00",
//     endDate: "2021-01-23T16:55:00",
//     eventName: "Workshop | Sherpa",
//     subtitle: "Iterations - Tools to help you prototype, design and iterate fast!",
//     location: "Hopin - Sessions"
//   },
//   {
//     startDate: "2021-01-23T17:00:00",
//     endDate: "2021-01-23T17:55:00",
//     eventName: "Workshop | GoDaddy",
//     subtitle: "Software Development",
//     location: "Hopin - Sessions"
//   },
//   {
//     startDate: "2021-01-23T18:00:00",
//     endDate: "2021-01-23T18:30:00",
//     eventName: "Resume Roast",
//     subtitle: "Hosted by Zack Harley from Ten Thousand Coffees",
//     location: "Hopin - Sessions"
//   },
//   {
//     startDate: "2021-01-23T18:30:00",
//     endDate: "2021-01-23T18:55:00",
//     eventName: "Dinner & Learn",
//     subtitle: "How to Create an Epic Founding Team",
//     location: "Hopin - Sessions"
//   },
//   {
//     startDate: "2021-01-23T19:00:00",
//     endDate: "2021-01-23T19:55:00",
//     eventName: "Panel Talk | Life as a Dev",
//     subtitle: "",
//     location: "Hopin - Sessions"
//   },
//   {
//     startDate: "2021-01-23T20:00:00",
//     endDate: "2021-01-23T20:55:00",
//     eventName: "Workshop | DDQIC",
//     subtitle: "Entrepreneurship/Innovation in the Technical World",
//     location: "Hopin - Sessions"
//   },
//   {
//     startDate: "2021-01-23T22:00:00",
//     endDate: "2021-01-23T23:00:00",
//     eventName: "Mini Event",
//     subtitle: "Bob Ross MS Paint Night & Pop Culture Jeopardy",
//     location: "Discord"
//   },
//   {
//     startDate: "2021-01-24T08:15:00",
//     endDate: "2021-01-24T09:00:00",
//     eventName: "Breakfast & Learn",
//     subtitle: "echoAR : Build a VR App in 15 Minutes",
//     location: "Hopin - Sessions"
//   },
//   {
//     startDate: "2021-01-24T09:00:00",
//     endDate: "",
//     eventName: "Hacking Ends!",
//     subtitle: "",
//     location: "Devpost"
//   },
//   {
//     startDate: "2021-01-24T09:30:00",
//     endDate: "2021-01-24T11:30:00",
//     eventName: "Demo Time + Judging",
//     subtitle: "Games, Draws & Prizes!",
//     location: "Discord & Devpost"
//   },
//   {
//     startDate: "2021-01-24T09:30:00",
//     endDate: "2021-01-24T11:30:00",
//     eventName: "Games!",
//     subtitle: "Among Us, Drawphone, Kahoot & Family Feud!",
//     location: "Discord - Games"
//   },
//   {
//     startDate: "2021-01-24T12:30:00",
//     endDate: "2021-01-24T13:00:00",
//     eventName: "Keynote Speaker",
//     subtitle: "Duke Butler (Head of DevOps Adoption at RBC)",
//     location: "Hopin - Sessions"
//   },
//   {
//     startDate: "2021-01-24T13:00:00",
//     endDate: "2021-01-24T14:00:00",
//     eventName: "Closing Ceremony",
//     subtitle: "",
//     location: "Hopin - Stage"
//   },
//   {
//     startDate: "2021-01-24T14:00:00",
//     endDate: "",
//     eventName: "Event Ends",
//     subtitle: "",
//     location: ""
//   },
// ];

const eventDays = [];

for (const event of schedule) {
  const start = moment(event.startDate).format("YYYY-MM-DD");
  if (!eventDays.includes(start)) {
    eventDays.push(start);
  }
}

eventDays.sort((a, b) => {
  return (
    moment(a, "YYYY-MM-DD").format("X") - moment(b, "YYYY-MM-DD").format("X")
  );
});

class EventSchedule extends Component {
  state = {
    selectedDay: eventDays[0]
  };

  addDurations(events) {
    return events.map((item) => {
      if (!item.endDate) {
        return item;
      }
      let duration = moment(item.endDate).diff(item.startDate, "minutes", true);
      if (duration > 59) {
        duration = Math.round((duration / 60) * 100) / 100;
        item.duration = `${duration} hr`;
      } else {
        item.duration = `${duration} min`;
      }
      return duration !== 1 ? { ...item, duration: `${item.duration}s` } : item;
    });
  }

  changeDay(selectedDay) {
    this.setState({ selectedDay });
  }

  render() {
    const eventsOnSelectedDay = schedule.filter(
      (item) =>
        (moment(item.startDate).format("YYYY-MM-DD") ===
          this.state.selectedDay &&
          Number(moment(item.startDate).format("H")) > 5) ||
        (moment(item.startDate)
          .subtract("days", 1)
          .format("YYYY-MM-DD") === this.state.selectedDay &&
          Number(moment(item.startDate).format("H")) <= 5)
    );

    const data = this.addDurations(eventsOnSelectedDay);

    return (
      <section
        id="schedule"
        style={{ background: "#fff", padding: "60px 0 0 0" }}
      >
        <ContentWrapper>
          <div
            style={{
              padding: "0px 0 50px 0",
              margin: "0 auto",
              overflow: "hidden"
            }}
          >
            <h1
              style={{
                textAlign: "center",
                position: "relative"
              }}
            >
              Event Schedule
              <sup>
                <a style={{ color: "#bababa" }} href="/#*">
                  *
                </a>
              </sup>
            </h1>
            <DaySwitcher
              days={eventDays}
              changeDay={(day) => this.changeDay(day)}
            />
            <h3
              {...css({
                textTransform: "uppercase",
                color: "#FFFFFF",
                marginLeft: "16px",
                "@media(max-width: 760px)": { marginLeft: 0 },
                fontWeight: 800
              })}
            >
              {moment(this.state.selectedDay, "YYYY-MM-DD").format(
                "dddd, MMMM Do, YYYY"
              )}
            </h3>
            <MediaQuery query="screen and (min-width: 760px)">
              <EventScheduleFullSizeTable data={data} />
            </MediaQuery>
            <MediaQuery query="screen and (max-width: 760px)">
              <EventScheduleCompressedTable data={data} />
            </MediaQuery>
            <p
              id="*"
              style={{
                textAlign: "center",
                position: "relative",
                zIndex: 2,
                color: "#bababa"
              }}
            >
              *Subject to Change
            </p>
          </div>
        </ContentWrapper>
      </section>
    );
  }
}

export default EventSchedule;